import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { GroupWithTicketTypeIds, PracticeWithTicketTypeIds } from '../../../../common/types';
import type { ImmutableState } from '../../types';
import setGroupsByTicketType from '../set-groups-by-ticket-type';
import setTicketTypesByGroup from '../set-ticket-types-by-group';
import setTicketTypesByPractice from '../set-ticket-types-by-practice';

const setRelationships =
	(groups: GroupWithTicketTypeIds[], practices: PracticeWithTicketTypeIds[]) =>
	({ dispatch }: StoreActionApi<ImmutableState>) => {
		dispatch(setTicketTypesByGroup(groups));
		dispatch(setGroupsByTicketType(groups));
		dispatch(setTicketTypesByPractice(practices));
	};

export default setRelationships;
